import React from 'react';
import { Outlet } from 'react-router-dom';

const Users = () => {
  return <Outlet />;
};

export default Users;
